import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap'

const HeaderWithIcons = ({ onSwapLayout, onFitToScreen }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '5px 12px',
        backgroundColor: '#f9f9f9',
        borderBottom: '1px solid #ddd',
      }}>
      {/* Left side */}
      <h2
        style={{
          color: '#F6764E',
          margin: 0,
        }}>
        Organization Tree
      </h2>

      {/* Right side */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Tooltip title='Swap Layout'>
          <IconButton
            onClick={onSwapLayout}
            sx={{
              color: '#F6764E',
            }}>
            <SwapHorizIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title='Fit Chart to Screen'>
          <IconButton
            onClick={onFitToScreen}
            sx={{
              color: '#F6764E',
            }}>
            <ZoomOutMapIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  )
}

export default HeaderWithIcons
